import * as React from "react";
import { SVGProps } from "react";

const Kleros = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 807 714"
    {...props}
  >
    <style>
      {".st0{opacity:.7;fill:#45464d;enable-background:new}.st1{fill:#656569}"}
    </style>
    <path
      d="M641.4 18.1 236 0 0 294.8l165.4 394.1 409.4 24.8 233.1-331.5z"
      className="st0"
    />
    <path d="M807.9 382.6 577 148.4l-60.8 449.3z" className="st1" />
    <linearGradient
      id="SVGID_1_"
      x1={157.357}
      x2={576.977}
      y1={351.118}
      y2={351.118}
      gradientTransform="matrix(1 0 0 -1 0 724.16)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#a3a2a5" />
      <stop offset={0.271} stopColor="#9f9ea0" />
      <stop offset={0.561} stopColor="#929194" />
      <stop offset={0.859} stopColor="#7c7c80" />
      <stop offset={1} stopColor="#707073" />
    </linearGradient>
    <path fill="url(#SVGID_1_)" d="M157.4 329.9 577 148.4l-60.8 449.3z" />
    <linearGradient
      id="SVGID_2_"
      x1={154.582}
      x2={452.734}
      y1={400.248}
      y2={695.523}
      gradientTransform="matrix(1 0 0 -1 0 724.16)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#969598" />
      <stop offset={0.34} stopColor="#908f92" />
      <stop offset={0.792} stopColor="#7f7f82" />
      <stop offset={1} stopColor="#757578" />
    </linearGradient>
    <path fill="url(#SVGID_2_)" d="M577 148.4 236 .4l-78.6 329.5z" />
    <linearGradient
      id="SVGID_3_"
      x1={177.562}
      x2={336.832}
      y1={404.415}
      y2={88.575}
      gradientTransform="matrix(1 0 0 -1 0 724.16)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#9e9ea0" />
      <stop offset={0.276} stopColor="#9b9b9d" />
      <stop offset={0.494} stopColor="#919194" />
      <stop offset={0.692} stopColor="#808083" />
      <stop offset={0.878} stopColor="#69696d" />
      <stop offset={1} stopColor="#55565a" />
    </linearGradient>
    <path fill="url(#SVGID_3_)" d="m157.4 329.9 8 359.4 350.8-91.6z" />
    <path fill="#757578" d="m577 148.4 64.4-129.9L236 .4z" />
    <path
      fill="#6c6d70"
      d="m641.4 18.5 166.5 364.1L577 148.4zm166.5 364.1L574.8 714.1l-58.6-116.4z"
    />
    <path
      fill="#55565a"
      d="m574.8 714.1-409.4-24.8 350.8-91.6zM236 .4 0 295.3l157.4 34.6z"
    />
    <path d="m0 295.3 165.4 394-8-359.4z" className="st1" />
    <path
      fill="#151a22"
      d="m534 210.3-42.5 322.1-250.7-193.9zm-33.9-64.2-234.3-101-49.3 212.3z"
      opacity={0.7}
    />
    <path
      fill="#23262e"
      d="M440.7 581.1 186 399.2l6.2 246.5zm324.4-199.3L591.6 205.6l-45.8 338.8z"
      opacity={0.7}
    />
    <path fill="#43444b" d="m500.4 620.8 37.8 72.3-252.6-16.2z" opacity={0.7} />
    <path
      fill="#34363d"
      d="m731.2 461.7-188 140.2 37.4 73zM642.3 69.4l99.4 213.2-135.9-138.2z"
      opacity={0.7}
    />
    <path fill="#36383f" d="M596.8 33.5 555 110 358.1 23.8z" opacity={0.7} />
    <path fill="#3b3c43" d="m202.6 68.2-55.4 234.9-111.8-23.7z" opacity={0.7} />
    <path d="m140.4 344.5 4.9 252.4L28.1 320.7z" className="st0" />
  </svg>
);

export default Kleros;
